'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import models_infos from 'Shared/models_infos';
let app = window.app;
const NO_VALUE = {
  label: ''
};
export default class ModelPicker extends Component {
  state = {
    loading: false,
    data: [],
    visible_data: [],
    id: String(++app.form_index),
    value: this.props.data || NO_VALUE
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.min_chars === 0) {
      component.searchModelData();
    }
    if (props.picked?.model?.id) {
      component.setState({
        value: props.picked
      });
    }
  }
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.picked?.model?.id !== prev_props.picked?.model?.id) {
      component.setState({
        value: props.picked
      });
    } else if (props['hide-results'] && props['hide-results'] !== prev_props['hide-results']) {
      component.setState({
        visible_data: state.data.filter(data => !props['hide-results'].includes(data.model.id))
      });
    }
  }
  searchModelData = searched => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    const model_infos = props.model_infos || models_infos[props.model];
    qwest.post(model_infos?.autocomplete_url, {
      searched: searched,
      ...(props.query_params || {})
    }).then(function (xhr, response) {
      const data = (response.data || []).filter(data => data.model.id !== props.data?.model?.id);
      const visible_data = props['hide-results'] ? data.filter(data => !props['hide-results'].includes(data.model.id)) : data.slice(0);
      component.setState({
        loading: false,
        data: data,
        visible_data: visible_data
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  selectValue = (event, data) => {
    let component = this,
      props = this.props,
      state = this.state;
    if (!props.clear_on_selection) {
      component.setState({
        value: data || {
          label: ''
        }
      });
    } else if (state?.visible_data?.length === 1) {
      component.setState({
        value: {
          label: ''
        }
      });
    }
    props.onPick({
      e: undefined,
      value: data?.model?.id || '',
      name: props.name,
      model: data?.model || {},
      model_type: data?.model_type
    });
  };
  handleChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const searched = event.target.value;
    if (component.search_timeout) {
      window.clearTimeout(component.search_timeout);
    }
    if (searched?.length >= props.min_chars || 2) {
      component.setState({
        loading: true
      });
      component.search_timeout = window.setTimeout(function () {
        component.search_timeout = undefined;
        component.searchModelData(searched);
      }, 240);
    } else {
      component.setState({
        data: [],
        visible_data: []
      });
    }
    if (!searched) {
      props.onPick({
        e: undefined,
        value: '',
        name: props.name
      });
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const model_infos = props.model_infos || models_infos[props.model];
    let base_class = 'c-model-finder',
      class_name = props.className;
    if (typeof props.bemit === 'string') {
      class_name += ' ' + base_class + '--' + props.bemit;
    } else {
      props.bemit.forEach(function (bem_modifier, index) {
        class_name += ' ' + base_class + '--' + bem_modifier;
      });
    }
    const label = props.label || model_infos?.picker_label;
    let suggestions = props.data ? [props.data].concat(state.visible_data) : undefined;
    if (props.filter) {
      suggestions = suggestions ? suggestions.filter(props.filter) : state.visible_data.filter(props.filter);
    }
    let status = props.status[props.name];
    const error_msg = status?.error ? status.error : undefined;
    let output = /*#__PURE__*/React.createElement("div", {
      className: class_name || base_class
    }, /*#__PURE__*/React.createElement(Autocomplete, {
      id: state.id,
      className: "m-ui-autocomplete",
      value: state.value,
      options: suggestions || state.visible_data,
      autoHighlight: true,
      onChange: component.selectValue,
      getOptionLabel: data => data.label,
      renderOption: option => option.label,
      loading: state.loading,
      filterOptions: options => options,
      disableCloseOnSelect: props['keep-open-on-select'] && (suggestions || state.visible_data)?.length > 1,
      noOptionsText: "Aucun r\xE9sultat",
      renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        placeholder: props.label === false ? label : undefined,
        label: props.label === false ? undefined : label,
        onChange: component.handleChange,
        error: error_msg ? true : false,
        helperText: error_msg,
        InputProps: {
          ...params.InputProps,
          autoComplete: 'off',
          endAdornment: /*#__PURE__*/React.createElement(Fragment, null, state.loading ? /*#__PURE__*/React.createElement(CircularProgress, {
            color: "inherit",
            size: 20
          }) : null, params.InputProps.endAdornment)
        }
      }))
    }));
    return output;
  }
}
ModelPicker.propTypes = {
  model: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.string,
  status: PropTypes.object,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  bemit: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  data: PropTypes.object
};
ModelPicker.defaultProps = {
  bemit: [],
  status: {}
};
